import SglTable from "components/ToolkitTable/SglTable"
import React from "react"
import moment from "moment"
import { Button } from "reactstrap"

function PastDueTable(props) {
  const columns = [
    {
      dataField: "customerName",
      text: "Cliente",
      sort: true,
    },
    {
      dataField: "projectName",
      text: "Projeto",
      sort: true,
    },
    {
      dataField: "date",
      text: "Data",
      sort: true,
      formatter: (cell) => cell ? moment.utc(cell).format("DD/MM/YYYY") : "-"
    },
    {
      dataField: "hours",
      text: "Horas",
      sort: true,
    },
    {
      dataField: "description",
      text: "Observação",
      sort: true,
    },
    {
    dataField: "_id",
    text: "Ações",
    headerAlign: "center",
    align: "center",
    formatter: (cell, row) => (
      <div className="d-flex justify-content-center align-items-center">
        <Button 
          color="link" 
          size="sm" 
          onClick={() => props.onEdit(row)}
          className="p-0 mr-2"
          title="Editar"
        >
          <i className="fas fa-edit text-primary" />
        </Button>
        <Button 
          color="link" 
          size="sm" 
          onClick={() => props.onDelete(row._id)}
          className="p-0"
          title="Excluir"
        >
          <i className="fas fa-trash text-danger" />
        </Button>
      </div>
    )
  }
  ]

  return (
    <>
      {props.data.length > 0 && (
        <SglTable columns={columns} data={props.data} rowClick={() => {}} />
      )}
    </>
  )
}

export default PastDueTable